module.exports = __webpack_public_path__ + "static/media/banner-em-casa-sim-sozinho-nunca.a1959af9.png";